import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@material-ui/core/';
import React, { ReactElement } from 'react';
import { ButtonV2, spacing } from '~/src/dash/publicaUI';

// This Component help make a quick dialog with an Accept / Refuse Button.
// A Trigger Button is also made. You need to provide your own component for this

interface IProps {
  // Trigger Component.
  // A onClick props will be set to this component to open the dialog.
  children?: React.ReactNode;

  // Info Hover on Trigger Component
  triggerComponentInfo?: string;

  // Dialog
  title: string;
  description: string;
  notice?: string;

  renderReactElement?: () => ReactElement;
  generateAcceptButtonStyles?: () => React.CSSProperties;

  // Accept Button
  acceptButtonTitle: string;
  acceptButtonCallBack?: () => void;

  // Refuse Button
  refuseButtonTitle: string;
  refuseButtonCallBack?: () => void;

  // disables the component opening
  disabled?: boolean;

  // disables the save button
  disableSave?: boolean;

  // if we want to open the popup window using a prop variable instead of the user clicking on the body button
  manualOpen?: boolean; // set this to true to open the popup
  handleClose?: () => void; // function called when the user close the popup (saving also triggers this)
}

export default function ConfirmationDialogButton(props: IProps) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    if (!props.disabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    if (props.handleClose) {
      props.handleClose();
    }
    setOpen(false);
  };

  return (
    <>
      {/* Trigger Button*/}
      {props.children &&
        (props.triggerComponentInfo !== undefined ? (
          <Tooltip title={props.triggerComponentInfo}>
            {React.cloneElement(props.children as any, { onClick: handleClickOpen })}
          </Tooltip>
        ) : (
          React.cloneElement(props.children as any, { onClick: handleClickOpen })
        ))}

      {/* Dialog*/}
      <Dialog
        open={open || !!props.manualOpen}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <div style={{ padding: `${spacing.large} ${spacing.extraLarge}` }}>
          <DialogTitle id='alert-dialog-title' style={{ padding: `${spacing.base} 0` }}>
            {props.title}
          </DialogTitle>
          <DialogContent style={{ padding: `${spacing.small} 0` }}>
            <DialogContentText id='alert-dialog-description'>
              {props.description}
              {props.renderReactElement && props.renderReactElement()}
            </DialogContentText>
            {!!props.notice && (
              <DialogContentText id='alert-dialog-notice' style={{ color: 'red' }}>
                {props.notice}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions style={{ padding: `${spacing.small} 0` }}>
            {/* Refuse Button*/}
            <Button
              onClick={() => {
                handleClose();
                if (props.refuseButtonCallBack !== undefined) {
                  props.refuseButtonCallBack();
                }
              }}
              color='secondary'
            >
              {props.refuseButtonTitle}
            </Button>

            {/* Accept Button*/}
            <ButtonV2
              autoFocus
              disabled={!!props.disableSave}
              style={{
                marginLeft: spacing.base,
                ...(!props.disableSave ? props.generateAcceptButtonStyles?.() || {} : {}),
              }}
              onClick={() => {
                handleClose();
                if (props.acceptButtonCallBack !== undefined) {
                  props.acceptButtonCallBack();
                }
              }}
            >
              {props.acceptButtonTitle}
            </ButtonV2>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
